import Grid from '@mui/material/Grid2';
import BotaoToggle from './BotaoToggle';

export default function AceiteComunicacao({ formik }) {
  return (
    <>
      <Grid size={12}>
        <BotaoToggle
          label="Aceita receber avisos e promoções por SMS"
          name="agreeToSms"
          value={!!formik.values.agreeToSms}
          onChange={() => {
            formik.setFieldValue(
              "agreeToSms",
              !formik.values.agreeToSms
            );
          }} />
      </Grid>

      <Grid size={12}>
        <BotaoToggle
          value={formik.values.agreeToWhatsapp}
          label="Aceita receber avisos e promoções por Whatsapp"
          name="agreeToWhatsapp"
          onChange={() => {
            formik.setFieldValue(
              "agreeToWhatsapp",
              !formik.values.agreeToWhatsapp
            );
          }} />
      </Grid>

      <Grid size={12}>
        <BotaoToggle
          label="Aceita receber avisos e promoções por e-mail"
          name="agreeToEmail"
          value={!!formik.values.agreeToEmail}
          onChange={() => {
            formik.setFieldValue(
              "agreeToEmail",
              !formik.values.agreeToEmail
            );
          }} />
      </Grid>
    </>
  )
}
